// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Dr2j0G {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  height: 100%;
  min-height: 0;
}

.R466s0 {
  height: 100%;
  min-height: 0;
}

.CvA07h {
  font-family: var(--font-family-base);
  font-size: var(--type-title-md-font-size);
  font-weight: var(--type-title-md-font-weight);
  line-height: var(--type-title-md-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
}

.A82FZC {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-dark);
  margin: 0;
  text-align: left;
}

.VFI_kn {
  display: flex;
  flex-direction: column;
  gap: var(--spacing-3);
  padding: var(--spacing-3);
  background: var(--surface-neutral-white);
  border-radius: var(--radius-s);
  box-shadow: var(--shadow-s);
  height: fit-content;
}

.yDn2tX {
  margin: 0;
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-lg-font-size);
  font-weight: var(--type-paragraph-lg-regular-font-weight);
  line-height: var(--type-paragraph-lg-regular-line-height);
  color: var(--text-neutral-dark);
}

.llLLn0 {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  width: 100%;
  padding: 12px 20px;
  border: 1px solid #cccccc;
  background: #fafafa;
  border-radius: var(--ibk-radius-s, 4px);
}

.Mn_ZdF {
  opacity: 0.6;
  border: none;
  font-size: var(--type-title-md-font-size);
  color: var(--text-neutral-dark);
  font-weight: var(--font-weight-regular);
  background-color: transparent;
  outline: none;
  width: 100%;
}

.qVwco4 {
  font-family: var(--font-family-base);
  font-size: var(--type-paragraph-md-font-size);
  font-weight: var(--type-paragraph-md-regular-font-weight);
  line-height: var(--type-paragraph-md-regular-line-height);
  color: var(--text-neutral-strong);
}

@media (max-width: 768px) {
  .Dr2j0G {
    gap: var(--spacing-2);
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/NewRechargePage/components/GlobalSettings/GlobalSettings.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,6CAA6C;EAC7C,6CAA6C;EAC7C,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,+BAA+B;EAC/B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;EACxC,8BAA8B;EAC9B,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,yCAAyC;EACzC,+BAA+B;EAC/B,uCAAuC;EACvC,6BAA6B;EAC7B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,yDAAyD;EACzD,yDAAyD;EACzD,iCAAiC;AACnC;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF","sourcesContent":[".stepContent {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  height: 100%;\n  min-height: 0;\n}\n\n.contentLayoutGlobalSettings {\n  height: 100%;\n  min-height: 0;\n}\n\n.title {\n  font-family: var(--font-family-base);\n  font-size: var(--type-title-md-font-size);\n  font-weight: var(--type-title-md-font-weight);\n  line-height: var(--type-title-md-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n}\n\n.subtitle {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-dark);\n  margin: 0;\n  text-align: left;\n}\n\n.summaryCard {\n  display: flex;\n  flex-direction: column;\n  gap: var(--spacing-3);\n  padding: var(--spacing-3);\n  background: var(--surface-neutral-white);\n  border-radius: var(--radius-s);\n  box-shadow: var(--shadow-s);\n  height: fit-content;\n}\n\n.summaryTitle {\n  margin: 0;\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-lg-font-size);\n  font-weight: var(--type-paragraph-lg-regular-font-weight);\n  line-height: var(--type-paragraph-lg-regular-line-height);\n  color: var(--text-neutral-dark);\n}\n\n.textInputAndSvg {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  height: 48px;\n  width: 100%;\n  padding: 12px 20px;\n  border: 1px solid #cccccc;\n  background: #fafafa;\n  border-radius: var(--ibk-radius-s, 4px);\n}\n\n.textInput {\n  opacity: 0.6;\n  border: none;\n  font-size: var(--type-title-md-font-size);\n  color: var(--text-neutral-dark);\n  font-weight: var(--font-weight-regular);\n  background-color: transparent;\n  outline: none;\n  width: 100%;\n}\n\n.textInfo {\n  font-family: var(--font-family-base);\n  font-size: var(--type-paragraph-md-font-size);\n  font-weight: var(--type-paragraph-md-regular-font-weight);\n  line-height: var(--type-paragraph-md-regular-line-height);\n  color: var(--text-neutral-strong);\n}\n\n@media (max-width: 768px) {\n  .stepContent {\n    gap: var(--spacing-2);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepContent": `Dr2j0G`,
	"contentLayoutGlobalSettings": `R466s0`,
	"title": `CvA07h`,
	"subtitle": `A82FZC`,
	"summaryCard": `VFI_kn`,
	"summaryTitle": `yDn2tX`,
	"textInputAndSvg": `llLLn0`,
	"textInput": `Mn_ZdF`,
	"textInfo": `qVwco4`
};
module.exports = ___CSS_LOADER_EXPORT___;
